import { FormattedMessage, useIntl } from 'react-intl';
import { LazyOutlet } from 'design-system/atoms/spinner-suspense';
import { pathOrgUserAccount, pathOrgUserPreference } from '../../utils/path';
import { useContextOrg } from '../../context/ContextOrg';
import LayoutHeader from '../../../components/LayoutHeader';
import { pathLogout } from '../../../constants/path';

export default function LayoutUserAccount() {
  const { orgId } = useContextOrg();
  const { formatMessage } = useIntl();
  return (
    <LayoutHeader
      breadcrumbs={[
        {
          label: <FormattedMessage defaultMessage="User account" id="i2OoDN" />,
        },
      ]}
      buttonGroups={[
        [
          {
            label: formatMessage({
              defaultMessage: 'Profile',
              id: 'itPgxd',
            }),
            action: pathOrgUserAccount({ orgId }),
            match: pathOrgUserAccount(),
          },
        ],
        [
          {
            label: formatMessage({
              defaultMessage: 'Preference',
              id: 'gBDHc8',
            }),
            action: pathOrgUserPreference({ orgId }),
            match: pathOrgUserPreference(),
          },
        ],
        [
          {
            label: formatMessage({
              defaultMessage: 'Logout',
              id: 'C81/uG',
            }),
            action: pathLogout(),
          },
        ],
      ]}
    >
      <LazyOutlet />
    </LayoutHeader>
  );
}
